export default function bunnyImgLoader({
  src,
  width,
  height,
  quality,
}: {
  src: string
  width?: number
  height?: number
  quality?: number
}) {
  if (src.startsWith('http')) {
    return src
  }

  if (
    src.includes(':') &&
    !src.includes('thunderkick:') &&
    !src.includes('pragmaticexternal:') &&
    !src.includes('softswiss:') &&
    !src.includes('mascot:') &&
    !src.includes('avatarux:') &&
    !src.includes('playtech:') &&
    !src.includes('nolimit:') &&
    !src.includes('slotmill:') &&
    !src.includes('hacksaw:')
  ) {
    return `https://cdn.softswiss.net/i/s3/${src.split('/')[1].replace(':', '/')}`
  }

  if (
    src.includes('thunderkick:') ||
    src.includes('softswiss:') ||
    src.includes('mascot:') ||
    src.includes('avatarux:') ||
    src.includes('playtech:') ||
    src.includes('hacksaw:')
  ) {
    src = `/thumbs${src}`
  }

  if (src.includes('nolimit:')) {
    src = `/thumbss${src}`
  }

  if (src.includes('=')) {
    return `https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA${src}`
  } else {
    return `https://imagedelivery.net/9WutbSXJqeY8Kc44mJMbvA${src}/public`
  }
}
